
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'accordion',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      expanded: false
    }
  }
})
